import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Paginator from '../paginator';
import { apiurl } from '../../utils/constants';
import { ExportToCSV } from '../../utils/exportxlsx';
import ReloadButton from '../../utils/reload';


function ListLedger() {

	const [ledger, setLedger] = useState([]);
	const [exportLedger, setExportLedger] = useState([]);

	const { mail, sapDB } = useSelector((state) => state.user);
	const [paginatedLedger, setPaginatedLedger] = useState([]);
	const [filteredLedger, setFilteredLedger] = useState([]);
	const [totalFiltered, setTotalFiltered] = useState(0);
	const [listCC, setListCC] = useState([]);
	const [listAcco, setListAcco] = useState([]);

	const [sinCC] = useState([]);
	const [cc300_399] = useState([]);
	const [cta4120101, setCta4120101] = useState([]);
	const [cta5110111, setCta5110111] = useState([]);
	const [show_sinCC, setShow_sinCC] = useState(false);
	const [show_c300_399, setShow_c300_399] = useState(false);
	const [show_cta4120101, setShow_cta4120101] = useState(false);
	const [show_cta5110111, setShow_cta5110111] = useState(false);

	const [typeTran, setTypeTran] = useState(0);
	const [filterCta_cod, setFilterCta_cod] = useState('');
	const filterCta_codMatch = listAcco.find(a => a.name === filterCta_cod || String(a.code) === filterCta_cod);
	const [filterCC, setFilterCC] = useState('');
	const filterCCMatch = listCC.find(c => c.name === filterCC || String(c.code) === filterCC);
	const [filterCotipo, setFilterCotipo] = useState('');
	const [startDate, setStartDate] = useState(() => {
		const now = new Date();
		return new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString().slice(0, 10);
	});
	const [endDate, setEndDate] = useState(() => {
		const now = new Date();
		const lastDayPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
		return lastDayPrevMonth.toISOString().slice(0, 10);
	});
	const [filterConum, setFilterConum] = useState('');
	const [filterCoglosa2, setFilterCoglosa2] = useState('');
	const currentUrl = window.location.href;



	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 20;

	const fetchLedger = useCallback(async () => {
		try {
			const response = await fetch(apiurl + `ledger?fechaInicio=${startDate}&fechaFin=${endDate}`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, user: mail
				})
			});

			const dataSet = await response.json();

			const data = Array.isArray(dataSet)
				? dataSet.sort((a, b) => {
					// Ordenar por cta_cod ASC
					if (a.cta_cod < b.cta_cod) return -1;
					if (a.cta_cod > b.cta_cod) return 1;
					// Si cta_cod es igual, ordenar por cc_cod ASC
					if (a.cc_cod < b.cc_cod) return -1;
					if (a.cc_cod > b.cc_cod) return 1;
					// Si cc_cod es igual, ordenar por ABS(doc_sdo) ASC
					return Math.abs(Number(a.doc_sdo)) - Math.abs(Number(b.doc_sdo));
				})
				: [];

			// Filtrar solo cuentas 4120101
			const cuentas4120101 = data.filter(item => item.cta_cod === '4120101');
			const sumPorDocSdo4 = {};
			cuentas4120101.forEach(item => {
				const key = Math.abs(Number(item.doc_sdo));
				sumPorDocSdo4[key] = (sumPorDocSdo4[key] || 0) + Number(item.doc_sdo);
			});
			const cantidad4 = Object.values(sumPorDocSdo4).filter(suma => suma !== 0).length;
			setCta4120101(cantidad4);


			// Filtrar solo cuentas 5110111
			const cuentas5110111 = data.filter(item => item.cta_cod === '5110111');
			const sumPorDocSdo = {};
			cuentas5110111.forEach(item => {
				const key = Math.abs(Number(item.doc_sdo));
				sumPorDocSdo[key] = (sumPorDocSdo[key] || 0) + Number(item.doc_sdo);
			});
			const cantidad = Object.values(sumPorDocSdo).filter(suma => suma !== 0).length;
			setCta5110111(cantidad);



			// Mapa para agrupar por cta_cod, cc_cod y valor absoluto de doc_sdo
			const pairMap = new Map();
			const usedIndexes = new Set();

			data.forEach((item, idx) => {
				const key = `${item.cta_cod}|${item.cc_cod}|${Math.abs(Number(item.doc_sdo))}`;
				if (!pairMap.has(key)) {
					pairMap.set(key, []);
				}
				pairMap.get(key).push({ idx, value: Number(item.doc_sdo) });
			});


			// Buscar y marcar pares opuestos
			pairMap.forEach(items => {
				const positives = items.filter(i => i.value > 0 && !usedIndexes.has(i.idx));
				const negatives = items.filter(i => i.value < 0 && !usedIndexes.has(i.idx));
				const pairCount = Math.min(positives.length, negatives.length);
				for (let i = 0; i < pairCount; i++) {
					usedIndexes.add(positives[i].idx);
					usedIndexes.add(negatives[i].idx);
				}
			});

			// Filtrar los que no están marcados como usados
			const filtered = data.filter((_, idx) => !usedIndexes.has(idx));

			// // --- Ajuste para facturas con equipos agrupados ---
			// const groupMap = new Map();
			// filtered.forEach((item, idx) => {
			// 	const key = `${item.doc_sdo}|${item.cta_cod}|${item.cc_cod}|${item.cotipo}`;
			// 	if (!groupMap.has(key)) {
			// 		groupMap.set(key, []);
			// 	}
			// 	groupMap.get(key).push({ ...item, _originalIdx: idx });
			// });

			// let adjusted = [...filtered];

			// groupMap.forEach(group => {

			// 	// Normaliza coglosa2 para evitar diferencias invisibles
			// 	const activosUnicos = new Set(group.map(i => ((i.coglosa2 || '').trim().toLowerCase())));
			// 	const allHaveCoglosa2 = group.every(i => i.coglosa2 && i.coglosa2.trim() !== '');

			// 	// Solo divide si hay más de un coglosa2 distinto
			// 	if (group.length > 1 && activosUnicos.size > 1 && allHaveCoglosa2) {
			// 		const divisor = activosUnicos.size;
			// 		const divididoDocSdo = Number((Number(group[0].doc_sdo) / divisor).toFixed(2));
			// 		const divididoDebit = Number((Number(group[0].Debit) / divisor).toFixed(2));
			// 		const divididoCredit = Number((Number(group[0].Credit) / divisor).toFixed(2));
			// 		group.forEach(i => {
			// 			adjusted[i._originalIdx] = {
			// 				...i,
			// 				doc_sdo: divididoDocSdo,
			// 				Debit: divididoDebit,
			// 				Credit: divididoCredit
			// 			};
			// 		});
			// 	}
			// });

			setLedger(filtered);
		} catch (error) {
			console.error('Error fetching ledger:', error);
		}
	}, [endDate, mail, sapDB, startDate]);

	const listFiltCC = useCallback(async () => {
		try {
			const response = await fetch(apiurl, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					table: `req__cent cent`,
					order: ` name`, user: mail
				})
			});

			if (response.ok) {
				const data = await response.json();
				const result = data.map(row => ({
					code: row.code,
					name: row.name,
				}));

				setListCC(result);
			} else {
				console.error('Error al obtener los usuarios');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	}, [mail]);

	const listFiltAcco = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					query: `SELECT code, name FROM inv__acco;`
				})
			});

			if (response.ok) {
				const data = await response.json();
				setListAcco(data.map(row => ({ code: row.code, name: row.name })));
			} else {
				console.error('Error al obtener las cuentas');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	}, [mail]);

	useEffect(() => {
		const filtLedger = ledger.filter(item => {

			const matchesType = typeTran === 'Débito' ? item.doc_sdo > 0 : typeTran === 'Crédito' ? item.doc_sdo < 0 : true;
			const matchesCtaCod = !filterCta_cod || (filterCta_codMatch
				? String(item.cta_cod) === String(filterCta_codMatch.code)
				: (String(item.cta_cod ?? '').toLowerCase().includes(filterCta_cod.toLowerCase())
					|| listAcco.some(a => String(a.code) === String(item.cta_cod) && (a.name || '').toLowerCase().includes(filterCta_cod.toLowerCase()))));
			const matchesCC = !filterCC || (filterCCMatch
				? String(item.cc_cod) === String(filterCCMatch.code)
				: (String(item.cc_cod ?? '').toLowerCase().includes(filterCC.toLowerCase())
					|| listCC.some(c => String(c.code) === String(item.cc_cod) && (c.name || '').toLowerCase().includes(filterCC.toLowerCase()))));
			const matchesCotipo = filterCotipo ? (item.cotipo || '').toLowerCase().includes(filterCotipo.toLowerCase()) : true;
			const matchesStartDate = startDate ? new Date(item.cofecha) >= new Date(startDate) : true;
			const matchesEndDate = endDate ? new Date(item.cofecha) <= new Date(endDate) : true;
			const matchesConum = filterConum ? (item.conum || '').toLowerCase().includes(filterConum.toLowerCase()) : true;
			const matchesCoglosa2 = filterCoglosa2 ? (item.coglosa2 || '').toLowerCase().includes(filterCoglosa2.toLowerCase()) : true;

			const matchesSinCC = show_sinCC
				? (item.cc_cod || '').length === 0 && item.cta_cod !== '4120101' && item.cta_cod !== '5110111'
				: true;
			const matchesC300_399 = show_c300_399 ? (item.cc_cod && Number(item.cc_cod) >= 300 && Number(item.cc_cod) <= 399) : true;


			let matches4120101 = true;
			if (show_cta4120101) {
				if (item.cta_cod === '4120101') {
					const absVal = Math.abs(Number(item.doc_sdo));
					const sameAbs = ledger
						.filter(i => i.cta_cod === '4120101' && Math.abs(Number(i.doc_sdo)) === absVal)
						.map(i => Number(i.doc_sdo));
					const pos = sameAbs.filter(val => val > 0).length;
					const neg = sameAbs.filter(val => val < 0).length;
					if (Number(item.doc_sdo) > 0) {
						matches4120101 = pos > neg;
					} else if (Number(item.doc_sdo) < 0) {
						matches4120101 = neg > pos;
					} else {
						matches4120101 = true;
					}
				} else {
					matches4120101 = false;
				}
			} else {
				if (item.cta_cod === '4120101') {
					matches4120101 = false;
				} else {
					matches4120101 = true;
				}
			}

			let matches5110111 = true;
			if (show_cta5110111) {
				if (item.cta_cod === '5110111') {
					const absVal = Math.abs(Number(item.doc_sdo));
					const sameAbs = ledger
						.filter(i => i.cta_cod === '5110111' && Math.abs(Number(i.doc_sdo)) === absVal)
						.map(i => Number(i.doc_sdo));
					const pos = sameAbs.filter(val => val > 0).length;
					const neg = sameAbs.filter(val => val < 0).length;
					if (Number(item.doc_sdo) > 0) {
						matches5110111 = pos > neg;
					} else if (Number(item.doc_sdo) < 0) {
						matches5110111 = neg > pos;
					} else {
						matches5110111 = true;
					}
				} else {
					matches5110111 = false;
				}
			} else {
				if (item.cta_cod === '5110111') {
					matches5110111 = false;
				} else {
					matches5110111 = true;
				}
			}

			return matchesType && matchesCtaCod && matchesCC && matchesCotipo && matchesStartDate && matchesEndDate && matchesConum && matchesCoglosa2 && matchesSinCC && matchesC300_399 && matches4120101 && matches5110111;

		});


		const mapped = filtLedger.map(item => ({
			debe: item.Debit,
			haber: item.Credit,
			doc_sdo: item.doc_sdo,
			glosacon: item.glosacon,
			cta_cod: item.cta_cod,
			cc_cod: item.cc_cod,
			cotipo: item.cotipo,
			conum: item.conum,
			cofecha: item.cofecha,
			coglosa: item.coglosa,
			coglosa1: item.coglosa1,
			coglosa2: item.coglosa2,
		}));
		setExportLedger(mapped);

		const startIndex = (currentPage - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;
		setPaginatedLedger(filtLedger.slice(startIndex, endIndex));
		setFilteredLedger(filtLedger);


	}, [ledger, currentPage, typeTran, filterCta_cod, filterCta_codMatch, filterCC, filterCCMatch, filterCotipo, startDate, endDate, filterConum, filterCoglosa2, show_sinCC, show_c300_399, show_cta4120101, show_cta5110111, listAcco, listCC]);


	useEffect(() => {
		setTotalFiltered(filteredLedger.length);
	}, [filteredLedger]);

	useEffect(() => {
		listFiltCC();
		listFiltAcco();
		fetchLedger();
	}, [fetchLedger, listFiltCC, listFiltAcco]);


	return (
		<>
			<form>
				<main>
					<h1 data-icon=''>Libro Mayor</h1>
					<nav>
						<article>
							<table>
								<thead>
									<tr>
										<td>Saldo</td>
										<td>Comentario</td>
										<td>Cuenta</td>
										<td>Centro de costo</td>
										<td>Documento</td>
										<td>Folio</td>
										<td>Activo fijo</td>
									</tr>
								</thead>
								<tbody>
									{
										paginatedLedger.map((item, index) => {

											return (
												<tr key={index}>
													<td style={item.doc_sdo < 0 ? { color: 'red' } : {}}>{item.doc_sdo}</td>
													<td className='ellipsis' style={{ maxWidth: '320px' }}>
														<div title={item.glosacon ? item.glosacon.replace(/"/g, "'") : ''}>{item.glosacon}</div>
														<div title={item.coglosa ? item.coglosa.replace(/"/g, "'") : ''}>{item.coglosa}</div>
													</td>
													<td>{item.cta_cod}</td>
													<td>
														<b>{item.cc_cod}</b>
														<div>{item.cc_name}</div>
													</td>
													<td>
														<b>{item.cotipo}</b>
														<div>{item.cofecha}</div>
													</td>
													<td>{item.conum}</td>
													<td>{item.coglosa2}</td>
												</tr>
											);
										})
									}
								</tbody>
							</table>
						</article>
					</nav>
					<nav>
						<article><Paginator totalItems={totalFiltered} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={setCurrentPage} /> </article>
					</nav>
				</main>
				<aside>
					<article>
						<h2>Acciones</h2>
						<fieldset>
							<ReloadButton onReload={fetchLedger} />
							<ExportToCSV apiData={exportLedger} fileName={"cppto"} />
						</fieldset>
					</article>
					<article>
						<h2>Advertencias</h2>
						<fieldset>
							<a href={currentUrl} className={show_sinCC ? 'active' : null} onClick={(e) => { e.preventDefault(); setShow_sinCC(!show_sinCC); }}><span>Sin Centro de costos ({sinCC.length})</span> {sinCC.length ? <orm-icon class="ora"></orm-icon> : ''}</a>
							<a href={currentUrl} className={show_c300_399 ? 'active' : null} onClick={(e) => { e.preventDefault(); setShow_c300_399(!show_c300_399) }}><span>Centro de costos 300 ({cc300_399.length})</span> {cc300_399.length ? <orm-icon class="ora"></orm-icon> : ''}</a>

							<a href={currentUrl} className={show_cta4120101 ? 'active' : null} onClick={(e) => { e.preventDefault(); setShow_cta4120101(!show_cta4120101) }}><span>Cuenta 4120101 ({cta4120101})</span> {cta4120101 ? <orm-icon class="ora"></orm-icon> : ''}</a>

							<a href={currentUrl} className={show_cta5110111 ? 'active' : null} onClick={(e) => { e.preventDefault(); setShow_cta5110111(!show_cta5110111) }}><span>Cuenta 5110111 ({cta5110111})</span> {cta5110111.length ? <orm-icon class="ora"></orm-icon> : ''}</a>

						</fieldset>
					</article>
					<article>
						<h2>Filtros</h2>
						<fieldset>
							<legend>Registro</legend>
							<select value={typeTran} onChange={e => setTypeTran(e.target.value)} >
								<option value=''></option>
								<option value='Débito'>Débito</option>
								<option value='Crédito'>Crédito</option>
							</select>
							<input type="search" placeholder="Cuenta" list="accounts" value={filterCta_cod} onChange={e => setFilterCta_cod(e.target.value)} />
						<datalist id="accounts">
							{
								listAcco.map(a => (
									<option key={a.code} value={a.code}>{a.name}</option>
								))
							}
						</datalist>
							<input type="search" placeholder="Centro de costos" list="cent" value={filterCC} onChange={e => setFilterCC(e.target.value)} />
							<datalist id="cent">
								{
									listCC.map(cc => (
										<option key={cc.code} value={cc.code}>{cc.name}</option>
									))
								}
							</datalist>
						</fieldset>
						<fieldset>
							<legend>Documento</legend>
							<input type="search" placeholder="Código" onChange={e => setFilterCotipo(e.target.value)} />
							<input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
							<input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
							<input type="search" placeholder="Folio" onChange={e => setFilterConum(e.target.value)} />
							<input type="search" placeholder="Activo fijo" onChange={e => setFilterCoglosa2(e.target.value)} />
						</fieldset>
					</article>
				</aside>
			</form>
		</>
	);
}

export default ListLedger;